module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAbElEQVR4Ae3WgQaAMBSG0fXiMVC96QL1BjUMyqAwLefwwzAu8AUA+KMhL+alsljeujHnHbct4epovEf2ygdbTwekygeppwOmygdzNwcUY95aFgMAWkgLaSEtBMCrFhobt5AW2r7fQlpICwEAJ5aZoOiBPbW6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/Menucontainer/baseline_format_list_bulleted_black_24dp.png
// module id = 63
// module chunks = 0